import React, { useEffect, useState } from "react";
import { motion, transform, useTransform, useScroll } from "framer-motion";
import { ChevronDown, ArrowRight, Github, Linkedin, Mail } from "lucide-react";
import Shreyas from "../../images/Shreyas Shrawage.jpg";
import "./Hero.css";

const Hero = ({ data }) => {
  const { scrollY } = useScroll();
  const xPos = useTransform(scrollY, (latest) => -latest * 0); // Map scrollY to a new transform value
  const yPos = useTransform(scrollY, (latest) => latest * 0.5); // Map scrollY to a new transform value
  const yPos2 = useTransform(scrollY, (latest) => latest * 0.5); // Map scrollY to a new transform value
  const yPos3 = useTransform(scrollY, (latest) => -latest * 0.3); // Map scrollY to a new transform value
  const yPos4 = useTransform(scrollY, (latest) => -latest * 0.35); // Map scrollY to a new transform value
  const yPos5 = useTransform(scrollY, (latest) => -latest * 0.4); // Map scrollY to a new transform value

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 1,
        ease: [0.25, 0.46, 0.45, 0.94],
        delay: 0.3,
      },
    },
  };

  const nameVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1,
        ease: [0.25, 0.46, 0.45, 0.94],
        delay: 0.1,
      },
    },
  };

  return (
    <section className="hero" id="home">
      <div className="hero-container">
        <div className="hero-grid">
          <motion.div
            className="hero-content"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            style={{ y: yPos2 }}
          >
            <motion.p
              className="hero-title"
              variants={itemVariants}
              // style={{ y: yPos3 }}
            >
              Hi, I'm
            </motion.p>

            <motion.h1
              className="hero-name"
              variants={nameVariants}
              // style={{ y: yPos2 }}
            >
              <span className="name-highlight">Shreyas</span>
              <br />
              Shrawage
            </motion.h1>

            <motion.p
              className="hero-title"
              variants={itemVariants}
              // style={{ y: yPos3 }}
            >
              Software Engineer / Full Stack Developer
            </motion.p>

            <motion.p
              className="hero-description"
              variants={itemVariants}
              // style={{ y: yPos4 }}
            >
              Crafting digital experiences with modern technologies.
              <br />
              Passionate about turning complex problems into{" "}
              <span className="underline-word">elegant</span> solutions.
            </motion.p>

            <motion.div
              className="hero-actions"
              variants={itemVariants}
              // style={{ y: yPos5 }}
            >
              <motion.a
                href="#projects"
                className="btn btn-primary"
                whileTap={{ scale: 0.98 }}
              >
                <span>Explore Work</span>
                <ArrowRight size={18} />
              </motion.a>
              <motion.a
                href="#contact"
                className="btn btn-secondary"
                whileTap={{ scale: 0.98 }}
              >
                Get in touch
              </motion.a>
            </motion.div>
          </motion.div>

          <motion.div
            className="hero-image"
            variants={imageVariants}
            initial="hidden"
            animate="visible"
            style={{ x: xPos, y: yPos }}
          >
            <div className="image-container">
              <motion.div
                className="image-wrapper"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <img src={Shreyas} alt="Shreyas Shrawage" />
                <div className="image-border"></div>
              </motion.div>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="hero-scroll"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2.5 }}
          onClick={() => {
            const aboutSection = document.getElementById("about");
            if (aboutSection) {
              aboutSection.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }}
        >
          <motion.div
            className="scroll-indicator"
            animate={{ y: [0, 6, 0] }}
            transition={{
              repeat: Infinity,
              duration: 2,
              ease: "easeInOut",
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <ChevronDown size={16} />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
